import { createSelector } from 'reselect'
import { locationDetailsSelector } from 'booking/selectors'
import { scanticketLocationSelector } from 'scanticket/selectors'

export const googlePayStateSelector = state => state.googlePay

export const googlePayIsReadyToPaySelector = createSelector(googlePayStateSelector, gp => gp?.isReadyToPay)
export const googlePayPendingSelector = createSelector(googlePayStateSelector, gp => gp?.pending === true)

export const googlePayDisabledSelector = createSelector(
    googlePayStateSelector,
    locationDetailsSelector,
    scanticketLocationSelector,
    (gp, bookingLocationDetails, scanticketLocation) => {
        const merchantId = bookingLocationDetails?.merchantId || scanticketLocation?.merchantID
        return !merchantId || !gp?.isReadyToPay
    }
)
